import { render } from "./WeeklyResults.vue?vue&type=template&id=15bb1411"
import script from "./WeeklyResults.vue?vue&type=script&lang=js"
export * from "./WeeklyResults.vue?vue&type=script&lang=js"

import "./WeeklyResults.vue?vue&type=style&index=0&id=15bb1411&lang=css"

import exportComponent from "C:\\Users\\abscu\\OneDrive\\Desktop\\htmlcss\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__